import {
  cn,
  Icon,
  type MarketIconSymbol,
  Typography,
  useMediaQuery,
} from "@kyan/ui";

import { type CompactAccountState } from "#/types/accounts";
import { PortfolioSymbol } from "#/types/markets";
import { formatCurrency } from "#/utils/valueFormatters";

interface PortfolioRiskDropdownItemProps {
  underlying: PortfolioSymbol;
  accountState: CompactAccountState;
}

export const PortfolioRiskDropdownItem: React.FC<
  PortfolioRiskDropdownItemProps
> = ({ underlying, accountState }) => {
  const { isSm } = useMediaQuery();

  const isUSDCUnderlying = underlying === PortfolioSymbol.USDC;

  return (
    <div
      className={cn("flex w-full gap-1.5 sm:gap-3", {
        "items-center justify-between pr-6": isUSDCUnderlying,
      })}
    >
      <Icon
        name={underlying.toLowerCase() as MarketIconSymbol}
        className={cn(
          "text-textPrimary -ml-1 flex size-6 items-center justify-center",
        )}
      />
      <div
        className={cn("place-items-start gap-0.5", {
          grid: !isUSDCUnderlying,
          "flex w-full justify-between": isUSDCUnderlying,
        })}
      >
        <Typography primary size={isSm ? 14 : 12} className="whitespace-nowrap">
          {isUSDCUnderlying ? "Unallocated USDC" : `${underlying} Portfolio`}
        </Typography>
        <Typography size={isSm ? 14 : 12}>
          {formatCurrency(accountState.equity)}
        </Typography>
      </div>
    </div>
  );
};
